import { render, staticRenderFns } from "./adminSingleOrder.vue?vue&type=template&id=90362e7c&scoped=true"
import script from "./adminSingleOrder.vue?vue&type=script&lang=js"
export * from "./adminSingleOrder.vue?vue&type=script&lang=js"
import style0 from "./adminSingleOrder.vue?vue&type=style&index=0&id=90362e7c&prod&lang=scss&scoped=true"
import style1 from "./adminSingleOrder.vue?vue&type=style&index=1&id=90362e7c&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90362e7c",
  null
  
)

export default component.exports